// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { loadScript } from '../../../../support';
/**
 * Component capable of rendering the `EmbedModule`
 * with the version set to `EmbedVersion.Iframe`.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let EmbedTwitterUi = class EmbedTwitterUi extends Vue {
    /**
     * Protects you from accessing an undefined variable.
     *
     * @returns - `this.iframe` if it exists
     * @returns - Empty string, if this.iframe hasn't been defined or is broken.
     */
    get html() {
        if (typeof this.twitter === 'string' && this.twitter.length > 0) {
            if (this.twitter.lastIndexOf('<script') < 0) {
                return this.twitter;
            }
            return this.twitter.substr(0, this.twitter.lastIndexOf('<script'));
        }
        return '';
    }
    /**
     * Loads Twitter script.
     */
    loadScript() {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return;
        }
        loadScript('https://platform.twitter.com/widgets.js')
            .then(() => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            this.$nextTick(() => window.twttr.widgets.load());
        })
            .catch(() => {
            console.warn('[EmbedTwitterUi] Failed to load Twitter script');
        });
    }
};
__decorate([
    Prop({ type: String, required: false })
], EmbedTwitterUi.prototype, "description", void 0);
__decorate([
    Prop({ type: String, required: true })
], EmbedTwitterUi.prototype, "twitter", void 0);
EmbedTwitterUi = __decorate([
    Component({
        name: 'EmbedIframeUi',
        mounted() {
            this.loadScript();
        },
        template: `
    <section>
      <div v-html="html" />
    </section>
  `
    })
], EmbedTwitterUi);
export { EmbedTwitterUi };
